export const UTM_MEDIUM_SHARE_MY_TASTING = 'share-my-tasting';
export const UTM_MEDIUM_QR_CODE = 'qr-code';
export const UTM_CAMPAIGN_KIOSK = 'kiosk';
export const UTM_SOURCE = 'vinhood-widget';
export const UTM_CAMPAIGN_AUTHENTICATED = 'authenticated';
export const UTM_CAMPAIGN_NON_AUTHENTICATED = 'non-authenticated';
